<script setup lang="ts">
import type { PrimitiveProps } from 'reka-ui'
import type { HTMLAttributes } from 'vue'

import { reactiveOmit } from '@vueuse/core'
import { cn } from '~ds/lib/utils'
import { Primitive } from 'reka-ui'

import type { PageContainerVariants } from '.'

import { pageContainerVariants } from '.'

const props = withDefaults(defineProps<PrimitiveProps & {
  size?: PageContainerVariants['size'];
  // Literal booleans, not PageContainerVariants['...']: the SFC compiler cannot
  // resolve the VariantProps<> generic to Boolean, so bare attributes would reach
  // cva as '' (falsy) in fresh builds. Literal Boolean props default to false
  // when absent, so gutter's recipe true-default is restated in withDefaults.
  gutter?: boolean;
  center?: boolean;
  class?: HTMLAttributes['class'];
}>(), {
  as: 'div',
  gutter: true,
  center: false,
})

const delegatedProps = reactiveOmit(props, 'size', 'gutter', 'center', 'class')
</script>

<template>
  <Primitive
    data-slot="page-container"
    :class="cn(pageContainerVariants({ size, gutter, center }), props.class)"
    v-bind="delegatedProps"
  >
    <slot />
  </Primitive>
</template>
